module.exports = __webpack_public_path__ + "img/Trans-Poses_0001_Billi.997800bf.png";